import { HTTPServiceClient } from '@/packages/http/service';
import * as endpoint from './endpoints';
import {
  OrgSubFundRequest,
  PaginatedResult,
  AddSubFundRequest,
  UpdateSubFundRequest,
  DeleteSubFundRequest,
  SubFundCostRequest,
  AddNewReportingPeriodRequest,
  SubFund,
  DeleteSubFundCostRequest
} from './types';

/**
 * --------------------------------------------------
 *	SubFund HTTP Serice
 * --------------------------------------------------
 **/
export const SubFundService = {
  async getSubFunds(
    orgSubFundRequest: OrgSubFundRequest
  ): Promise<PaginatedResult> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ORGANIZATION_SUB_FUNDS(orgSubFundRequest)
    );
    return data;
  },
  async getFilterSubFunds(
    orgSubFundRequest: OrgSubFundRequest
  ): Promise<SubFund[]> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ORGANIZATION_SUB_FUNDS(orgSubFundRequest, true)
    );
    return data.data;
  },

  async postSubFund(addSubFundRequest: AddSubFundRequest): Promise<Response> {
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_SUB_FUND(addSubFundRequest.orgId),
      addSubFundRequest
    );
    return data;
  },

  async putSubFund(
    updateSubFundRequest: UpdateSubFundRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.put(
      endpoint.PUT_SUB_FUND(
        updateSubFundRequest.orgId,
        updateSubFundRequest.id
      ),
      updateSubFundRequest
    );
    return data;
  },

  async deleteSubFund(
    deleteSubFundRequest: DeleteSubFundRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.delete(
      endpoint.DELETE_SUB_FUND(
        deleteSubFundRequest.orgId,
        deleteSubFundRequest.id,
        deleteSubFundRequest.investmentId
      )
    );
    return data;
  },

  async postSubFundCost(
    subFundCostRequest: SubFundCostRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_SUB_FUND_COST(
        subFundCostRequest.orgId,
        subFundCostRequest.investmentId
      ),
      subFundCostRequest
    );
    return data;
  },

  async postNewReportingPeriod(
    addNewReportingPeriod: AddNewReportingPeriodRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_NEW_REPORTING_PERIOD(
        addNewReportingPeriod.orgId,
        addNewReportingPeriod.id
      ),
      addNewReportingPeriod
    );
    return data;
  },

  async deleteSubFundCost(
    deleteSubFundCostRequest: DeleteSubFundCostRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.delete(
      endpoint.DELETE_SUB_FUND_COST(
        deleteSubFundCostRequest.orgId,
        deleteSubFundCostRequest.id,
        deleteSubFundCostRequest.investmentId
      )
    );
    return data;
  }
};
